import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalDirective, ToastService } from 'ng-uikit-pro-standard';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';

interface IHeaderForm {
  respuesta: string
  observaciones: string
}

interface ICallbackInput {
  (aprobado: boolean, observacion: string, additionalData: any): void
}

@Component({
  selector: 'app-empresas-recibidos-modal-observaciones',
  templateUrl: './modal-observaciones.component.html',
  styleUrls: ['../empresas-recibidos.component.scss']
})
export class EmpresasRecibidosModalObservacionesComponent implements OnInit {

  @Input() relativeId: string = ''
  public idAprobado = `${this.relativeId}__AE_EMP_RECIB_RTA_APROBADO__`
  public idRechazado = `${this.relativeId}__AE_EMP_RECIB_RTA_RECHAZAD__`

  @ViewChild('observacionesModal', { static: true }) modalObservaciones: ModalDirective;

  // Constants
  readonly EMP_RECIB_RTA_APROBADO: String = `_EMP_RECIB_RTA_APROBADO_`
  readonly EMP_RECIB_RTA_RECHAZADO: String = `_EMP_RECIB_RTA_RECHAZADO_`

  // Form
  formHeader: FormGroup;
  initialValues: IHeaderForm

  // Callbacks
  private acceptCallback: ICallbackInput;
  private additionalData: any

  // Utils
  private log: any

  constructor(
    private clog: ConsoleService,
    private toastService: ToastService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService
  ) {
    this.log = this.clog.log('EMPRESAS-RECIBIDOS-OBSERVACIONES')
  }

  ngOnInit() {
    this.createFormInitialValues()
    this.createForms()
    this.idAprobado = `${this.relativeId}__AE_EMP_RECIB_RTA_APROBADO__`
    this.idRechazado = `${this.relativeId}__AE_EMP_RECIB_RTA_RECHAZAD__`
  }

  createFormInitialValues() {
    this.initialValues = {
      respuesta: null,
      observaciones: null,
    }
  }

  private createForms() {
    this.formHeader = this.fb.group({
      respuesta: [null, [Validators.required]],
      observaciones: [null, [Validators.required, Validators.maxLength(300)]],
    });
  }

  show({ acceptCallback, additionalData }: { acceptCallback: ICallbackInput, additionalData: any }) {
    this.acceptCallback = acceptCallback
    this.additionalData = additionalData
    this.setInitialValues()
    this.modalObservaciones.show()
  }

  private setInitialValues() {
    this.formValidatorsService.setInitialState(this.formHeader, this.initialValues)
  }

  agregarObservacion() {
    this.formValidatorsService.validateAllFormFields(this.formHeader)
    if (!this.formHeader.valid)
      return

    const { respuesta, observaciones } = this.formHeader.value

    if (this.acceptCallback)
      this.acceptCallback(respuesta === this.EMP_RECIB_RTA_APROBADO, observaciones, this.additionalData)

    this.modalObservaciones.hide()
  }

}
